const apiMethods = {
	get: 'get',
	patch: 'patch',
	post: 'post',
	put: 'put',
	delete: 'delete',
}

const apiHeaders = {
	acceptType: 'application/json',
	deviceType: 'device-type',
	web: 'Web',
	preventDefaultLoader: 'prevent-default-loader',
	preventDefaultToast: 'prevent-default-toast',
	authToken: 'auth-token',
}

export const apiEndPoints = {
	signIn: '/signIn',
	signUp: '/signUp',
	getAllCountries: '/countriesFieldsList',
	getAllStates: '/statesFieldsList',
	getAllDistricts: '/districtsFieldsList',
	getUserProfile: '/getUserProfile',
	signOut: '/logout',
	updatePreferredLanguage: '/updatePreferredLanguage',
	getPreferredLanguage: '/getPreferredLanguage',
	editUserProfile: '/editUserProfile',
	getKycDetailsOfUser: '/getKycDetailsOfUser',
	addAndUpdateKycDetails: '/addAndUpdateKycDetails',
	getBankDetailsOfUser: '/getBankDetailsOfUser',
	addAndUpdateBankDetails: '/addAndUpdateBankDetails',
	forgotPassword: '/forgotPassword',
	changePassword: '/changePassword',
	changeTransactionPasswordRequest: '/changeTransactionPasswordRequest',
	changeTransactionPassword: '/changeTransactionPassword',
	getsponsorteam: '/getsponsorteam',
	getCategories: '/common/getCategories',
	getAllCategories: '/common/getAllCategories',
	gameProductsListing: '/website/gameProductsListing',
	gameProductDetails: (customUrl) => `/website/getGameProductDetails/${customUrl}`, // Dynamic endpoint
	nonDigitalProductDetails: (productId) => `/website/non-digital-product-details/${productId}`, // Dynamic endpoint
	digitalProductDetails: (productId) => `/website/getDigitalProductDetails/${productId}`, // Dynamic endpoint
	frequentlyBroughtTogetherProducts: `/website/get-frequestly-brought-together-products`,
	createProductReview: '/createProductReview',
	getUserProductReview: '/getUserProductReview',
	updateProductReview: '/updateProductReview',
	getPerticularProductAllReviews: '/getPerticularProductAllReviews',
	updateProductLikeAndDislikeCount: '/updateProductLikeAndDislikeCount',
	addToCart: '/addToCart',
	getCartDetails: '/getCartDetails',
	deleteCartProducts: '/deleteCartProducts',
	validateSponserId: '/order/validateSponserId',
	applyVoucher: '/applyVoucher',
	removeVoucher: '/removeVoucher',
	addShippingAddress: '/addShippingAddress',
	getShippingAddress: (userId) => `/getShippingAddress/${userId}`,
	orderSummary: '/orderSummary',
	validatePaymentMethods: '/order/validatePaymentMethods',
	pointsListingUser: '/mystuff/pointsListingInUser',
	eGiftShoppingListingUser: '/mystuff/giftVoucherListingInUser',
	myGiftListingUser: '/user/giftOrdersListing',
	getWalletDetails: '/mywallet/getWalletDetails',
	creditDebitListing: '/website/creditDebitListing',
	fundsReceivedHistoryListing: '/website/fundsReceivedHistoryListing',
	fundsTransferHistoryListing: '/website/fundsTransferHistoryListing',
	fundsTransferListing: '/website/fundTransfer',
	testimonialListing: '/addTestimonial',
	getTestimonialListing: '/getTestbyid',
	supportTicketCreate: '/createSupportTicket',
	ticketCategoriesListing: '/ticketCategoriesListing',
	getUserWithdrawlMiscellanousData: '/get-user-withdrawl-miscellanous-data',
	getAdminSettings: '/user/getAdminSettings',
	verifyBankDetails: '/verifyBankDetails',
	createWithdrawRequest: '/createWithdrawRequest',
	getWithdrawlHistory: '/get-withdrawl-history',
	withdrawalPayoutInvoiceDownload: (withdrawal_id) => `/download/payoutInvoice/${withdrawal_id}`,
	getReferralCommissionOfUser: '/myearns/gameCommissionListingInUser',
	sponsorCommissionListing: '/myearns/sponsorCommissionListingInUser',
	aurCommissionListingInUser: '/myearns/aurListingInUser',
	addAndUpdatePortfolio: '/addAndUpdatePortfolio',
	getPortfolioDetails: '/getPortfolioDetails',
	referralCommTeamView: (_id) => `/myearns/getGameTreeDetails/${_id}`,
	setDefaultAddress: '/setDefaultAddress',
	updateShippingAddress: '/updateShippingAddress',
	orderTreeDetails: (_id) => `/myearns/getOrderTreeDetailsOfUser/${_id}`,
	getTeamTreeDetails: '/getTeamTreeDetails',
	getPendingTeamMembers: '/getPendingTeamMembers',
	getPendingLevelDetails: '/getPendingLevelDetails',
	addTeamMember: '/addTeamMember',
	deleteShippingAddress: '/deleteShippingAddress',
	getUserDashboardDetails: '/getUserDashboardDetails',
	allorders: '/allorders',
	mobileOrders: '/mobile-allorders',
	cancelOrder: '/cancelOrder',
	refundOrder: '/refundOrder',
	replacementOrder: '/replacementOrder',
	downloadGameInvoiceHTML: (_id) => `/downloadGameInvoiceHTML/${_id}`,
	getGiftInvoice: (_id) => `/giftOrderInvoiceDetails/${_id}`,
	userDashboardData: '/user-dashboard-data',
	getticketListing: '/supportTickets/ticketsListing',
	addMessage: 'chat/user/addmessage',
	userGameProductsListing: '/user/userGameProductsListing',
	getTicketMessages: (ticketNumber) => `/chat/getTicketMessages/${ticketNumber}`,
	generatePresignedUrl: '/generate-presigned-url',
	signInAsUser: (_id) => `/admin/signAsUser/${_id}`,
	purchasedGames: (gameId) => `/user/gamesListInGameProducts/${gameId}`,
	getSpecificOrderDetails: (data) => `/get-specific-order-details/${data.orderId}/${data.productId}`,
	getVerifiedBankDetailsOfUser: '/getVerifiedBankDetailsOfUser',
	getProductsList: '/website/productsListing',
	searchProducts: '/website/searchProducts',
	getNonDigitalCategories: '/common/getNonDigitalCategories',
	updateCartQuantity: '/update-cart-quantity',
}

export { apiHeaders, apiMethods }
